import React, { ReactElement } from "react";
import { RouterProps, Router } from "@swiggy-private/core-ui";
import { CartRoutes } from "@swiggy-private/cart-client";
import { RouteContainer, CheckoutRoute, isQuickCheckoutFlow } from "@swiggy-private/checkout-core";
import { PaymentRoutes, OUT_IN_ROUTES } from "@swiggy-private/payment-client";

export type CheckoutRouterProps = Omit<RouterProps<CheckoutRoute>, "children">;

export const CheckoutRouter = (props: CheckoutRouterProps): ReactElement => {
    const routes = [...PaymentRoutes];
    routes.push(...CartRoutes);
    // QC/AIP only: CartMain nests QC ↔ MRO (and other cart siblings) under one outer key
    // (`CheckoutRoute.CART`). Height / bg callbacks are registered via
    // `navigateTo(..., { onTransitionComplete })` and flushed by the *nested*
    // CartMain ScreenTransition. Without this flag, outer MiniRouter would clear
    // that pending callback on same-outer-key sibling hops (and on RouteContainer
    // sync navigations that omit the options object). Leave off for BAU.
    const preservePendingTransitionOnSiblingNav = isQuickCheckoutFlow();
    return (
        <Router
            {...props}
            container={RouteContainer}
            nonOverlappingTransitionRoutes={OUT_IN_ROUTES}
            preservePendingTransitionOnSiblingNav={preservePendingTransitionOnSiblingNav}
        >
            {routes}
        </Router>
    );
};
